import { VERSION } from "../constants";
import { instance } from "../../axios";

// Only the latest request is shown: switching the window or the company
// quickly must not let an older answer overwrite a newer one
let latestRequest = 0;

// Admin only: app builds of the users active over the last `days` days,
// optionally limited to the customers of one company
const getVersionsAction = (days, companyId) => {
  return (dispatch) => {
    const request = ++latestRequest;
    dispatch({ type: VERSION.GET_VERSIONS });
    const params = new URLSearchParams({ days });
    if (companyId) params.append("company_id", companyId);
    instance
      .get(`/version?${params.toString()}`)
      .then((results) => {
        if (request !== latestRequest) return;
        dispatch({ type: VERSION.GET_VERSIONS_SUCCESS, payload: results.data });
      })
      .catch((error) => {
        if (request !== latestRequest) return;
        dispatch({ type: VERSION.GET_VERSIONS_FAILURE, payload: error });
      });
  };
};

export { getVersionsAction };
